
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/distributor-pos",
      function () {
        return require("private-next-pages/distributor-pos.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/distributor-pos"])
      });
    }
  